export const NAVIGATION_ITEMS = [
  { key: 'home', label: 'Home' },
  { key: 'about', label: 'About' },
  { key: 'contact', label: 'Contact' }
];

export const CONTACT_INFO = {
  email: 'hello@aethermindtech.com',
  phone: '+1 (555) 123-4567',
  address: '123 Business St\nNew York, NY 10001'
};

export const SOCIAL_LINKS = [
  { name: 'Facebook', url: '#', bgColor: 'bg-blue-600' },
  { name: 'Twitter', url: '#', bgColor: 'bg-blue-400' },
  { name: 'LinkedIn', url: '#', bgColor: 'bg-blue-700' }
];

export const BUSINESS_HOURS = [
  { day: 'Monday - Friday', time: '9:00 AM - 6:00 PM' },
  { day: 'Saturday', time: '10:00 AM - 4:00 PM' },
  { day: 'Sunday', time: 'Closed' }
];